export function stringComparator(a: string | undefined, b: string | undefined) {
    let aString = a || '';
    let bString = b || '';
    return aString.localeCompare(bString);
}